<script setup>
defineProps({
  imgSrc: {
    type: String,
    required: false,
  },
  backgroundColor: {
    type: String,
    required: true,
    default: 'red',
  },
  useBackgroundImage: {
    type: Boolean,
    default: true,
  },
  footerHeight: {
    type: Number,
    default: 140,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <div class="flex flex-col h-full rounded-xl relative">
    <div v-if="useBackgroundImage" class="flex flex-1 overflow-hidden">
      <img
        v-optimized="{ lazy: true, src: imgSrc }"
        class="object-cover rounded-t-xl"
        :style="{
          backgroundColor,
          height: '100%',
          width: '100%',
          minHeight: '317px',
        }"
      />
    </div>

    <slot name="main" v-else></slot>

    <div
      v-if="showFooter"
      class="flex flex-col mt-auto w-full px-5 place-content-center rounded-b-xl -top-[1px]"
      :style="{ backgroundColor, height: `${footerHeight}px` }"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>
